export interface Param {
  readonly key: string;
  readonly value: any;
}

export const ParamUtils = {
  create({ key, value }: { key: string; value: any }): Param {
    return {
      key,
      value,
    };
  },

  fromMap(map: { [key: string]: any }): Param {
    return {
      key: typeof map["key"] === "string" ? map["key"] : "",
      value:
        typeof map["value"] === "string"
          ? map["value"]
          : Array.isArray(map["value"])
            ? (map["value"] as string[])
            : "",
    };
  },

  toMap(param: Param): { [key: string]: any } {
    return {
      key: param.key,
      value: param.value,
    };
  },

  toJson(param: Param): string {
    return JSON.stringify(ParamUtils.toMap(param));
  },

  empty(): Param {
    return { key: "", value: "" };
  },

  toString(param: Param): string {
    return `Param(key: ${param.key}, value: ${param.value})`;
  },

  equals(param1: Param, param2: Param): boolean {
    return (
      param1.key === param2.key && JSON.stringify(param1.value) === JSON.stringify(param2.value)
    );
  },

  copyWith(param: Param, { key, value }: { key?: string; value?: any }): Param {
    return {
      key: key ?? param.key,
      value: value ?? param.value,
    };
  },
};
